import axios from 'axios';
import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/logo.svg';
import errorFace from '../../assets/images/errorFace.svg';
import pinData from '../../types/pinData.type';
import { useNavigate , useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
// import { JSEncrypt } from 'jsencrypt'

function SetPassword() {
  
  let pub_key = "RNTiVyc+j2UnbIGaewMGMp6yDcjGqCBvPSUEYmIMwbC7cKBZDjcXjur2VourTRr9My8fYr9+QCtpyKMnQd44iGkqPoVn9Qtf+1ZTMtN5fa09xkxpYWuUeKZUfksToneAEiQ4dn9IwUA0uWQAsEEeb3ell11RBlm71Qrplu/UlBM="

  useEffect(() => {
    setIsActive(true);
    setTimeout(() => {
      setIsHiden(true);
    }, 1000);
  }, []);

  const [isActive, setIsActive] = useState(false);
  const [hideTransition, setIsHiden] = useState(false);

  const navigate = useNavigate();
  const state = useLocation();
  let cifrado = "RNTiVyc+j2UnbIGaewMGMp6yDcjGqCBvPSUEYmIMwbC7cKBZDjcXjur2VourTRr9My8fYr9+QCtpyKMnQd44iGkqPoVn9Qtf+1ZTMtN5fa09xkxpYWuUeKZUfksToneAEiQ4dn9IwUA0uWQAsEEeb3ell11RBlm71Qrplu/UlBM="

  async function nextChallenge( ) {
    try {
      const pinData: pinData = {
        challengeName: "NEED_PASSWORD",
        termOfServiceRespond: "wally_1-0-0",
        sessionId: state.state.sessionId,
        securityProfileId: "P1-Web",
        passwordRespond : {
            password: cifrado
        }
      }
     
      const { data, status } = await axios.post<pinData>(
        'http://10.8.0.200:8000/kraken/api/enrollment/challengeRespond',
        pinData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            Accept: '*/*',
          },
        },
      );
      if (data.challengeName === "DONE") {
        navigate("/bienvenido",{
          state: {
            name: data.enrollmentCustomer ? data.enrollmentCustomer.firstName : state.state.name,
            sex: data.enrollmentCustomer ? data.enrollmentCustomer.sex : "default",
          }
        });
      }
  
      } catch (error) {
       
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 409) {
          Swal.fire({
            title: '¡Ooops!',
            text:error.response?.data.message,
            imageUrl: errorFace,
            imageWidth: 150,
            imageHeight: 150,
            imageAlt: 'Custom image',
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
                navigate('/');
            }
          })
          return;
        }
        Swal.fire({
          title: '¡Ooops!',
          text:error.response?.data.message,
          imageUrl: errorFace,
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: 'Custom image',
        })
          
      } else {
        console.log('unexpected error: ', error);
        return 'An unexpected error occurred';
      }
    }
  }
    const [password, setPassword] = useState<string>("");
    const [isShaked, setError] = useState(false);
    const [errorMessage, setMessage] = useState<string>("");

    const normalInput = "w-full bg-gray-50 text-center border border-gray-300 text-gray-900 text-4xl rounded-full  focus:outline-wallyBlue block pb-3 pt-5  dark:bg-inputDark dark:border-gray-600 dark:placeholder-gray-100 dark:text-white dark:focus:ring-red-500 dark:focus:border-red-400"
    const errorInput = "w-full shakeError bg-gray-50 text-center border border-red-400 text-gray-900 text-4xl rounded-full  focus:outline-wallyBlue block pb-3 pt-5  dark:bg-inputDark dark:border-gray-600 dark:placeholder-gray-100 dark:text-white dark:focus:ring-red-500 dark:focus:border-red-400"
    const inputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const enteredValue = event.target.value.trim();
        setPassword(enteredValue);
    };

    const registerButton = () => {
        setError(false);
        if (password.length < 4 ) {
            setError(true);
            setMessage("El pin debe tener al menos 4 números.");
            return;
        }
        if (isNaN(Number(password))) {
            setError(true);
            setMessage("El pin debe ser solo numérico.");
            return;
        }
        const arr = Array.from(String(password), Number);
        var results = [];
        var limit   = arr.length - 1; 
        var sequence = 0;
        for (var i = 0; i < limit; ++i) {
          if (new Set([arr[i], arr[i+1], arr[i+2]]).size === 1) {
            setError(true);
            setMessage("El pin no puede contener 3 números iguales consecutivos.");
            return;
          } 
          var diff = arr[i+1] - arr[i];
          if (sequence && sequence === diff) {
            results.push(i-1);
            continue;
          }
          sequence = (diff === 1 || diff === -1) // or ... Math.abs(diff) === 1
                   ? diff
                   : 0;
         
        }
        
        if (results.length > 0) {
            setError(true);
            setMessage("El pin no puede contener números consecutivos.");
            return;
        }
        setError(false);
        nextChallenge();
    };
    
  return (
    <div className="dark:bg-bgDark h-full p-3 flex flex-col h-screen justify-between">
      <header className="w-full p-20">
        <img src={logo} className="h-12 mx-auto" alt="Wally" />
      </header>
      <div className={hideTransition ? 'transitionContainer hide' : 'transitionContainer'}>
        <div className={isActive ? 'transition show' : 'transition'}>
          <div className="layer one"></div>
          <div className="layer two"></div>
          <div className="layer three"></div>
        </div>
      </div>
      <div className="container mb-auto  max-w-md mx-auto ">
        <div className={hideTransition ? 'w-full mx-auto show' : 'w-full mx-auto'}>
          <h1 className="text-2xl text-wallyGray font-semibold">Crea tu clave</h1>
          <p className="text-gray-400 mt-2">Con esta clave podras acceder a la app.</p>
          <form action="">
            <div className="relative mt-7">
              <input 
                  type="password"
                  maxLength={6}
                  minLength={4}
                  pattern="[0-9]*"
                  inputMode='numeric'
                  className={isShaked ? errorInput : normalInput }
                  placeholder="* * * * * *"
                  value={password}
                  onChange={inputHandler}
                  onFocus={() => setError(false)}
              />
              {isShaked ?
              <p className="text-xs mt-2 text-center text-red-500" >{errorMessage}</p>
              : null}
            </div>
          </form>
        </div>
      </div>
        <div className="container mb-20  max-w-md mx-auto ">
            <div className="relative text-center w-full">
                <button  onClick={registerButton} className="text-white text-xl bg-wallyBlue w-full rounded-full p-4 mt-40">
                REGISTRARME
                </button>
            </div>
        </div>
    </div>
  );
}

export default SetPassword;